import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEqual from 'lodash.isequal';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { State } from 'b2b-apps/shop/common/redux/types';
import { fetchContentCollection } from 'b2b-apps/shop/content/redux/contentCollections/actionCreators';
import { getCollectionById } from 'b2b-apps/shop/content/redux/contentCollections/selectors';
import { ContentCollectionEntryType } from 'b2b-apps/shop/content/redux/contentCollections/types';

type UseCollectionReturnType = RemoteRecord<ContentCollectionEntryType[]>;

const CONTENT_COLLECTION = {
  infobar: 'infobar',
  onboarding: 'onboarding',
};

const useCollection = (
  collectionId: string,
  filters: Record<string, any> = {},
): UseCollectionReturnType => {
  const dispatch = useDispatch();
  const content = useSelector(
    useCallback(
      (state: State) => getCollectionById(state, collectionId),
      [collectionId],
    ),
    isEqual,
  );

  useEffect(
    (): void => {
      if (!content.wasStarted) {
        dispatch(fetchContentCollection(collectionId, filters));
      }
    },
    [collectionId, content.wasStarted, dispatch, filters],
  );

  return content;
};

export {
  CONTENT_COLLECTION,
  useCollection,
};

export type {
  UseCollectionReturnType,
};
